import React from "react";
import { PremiumBadgeTemplate } from "themes/common/components";

const PremiumBadge = (props) => {
    return <PremiumBadgeTemplate {...props} />;
};

export default PremiumBadge;
